<template>
  <div class="Essence h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="essence"
      :options="options"
      :options2="options2"
      :func1="this.tier"
      :func2="this.type"
      filter1="Tier"
      filter2="Type"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Two-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Essence",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "tier",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "0", value: "0", disabled: false },
        { text: "1", value: "1", disabled: false },
        { text: "2", value: "2", disabled: false },
        { text: "3", value: "3", disabled: false },
        { text: "4", value: "4", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
        { text: "7", value: "7", disabled: false },
        { text: "8", value: "8", disabled: false },
      ],
      options2: [
        { text: "All", value: "All", disabled: false },
        { text: "Anger", value: "Anger", disabled: false },
        { text: "Anguish", value: "Anguish", disabled: false },
        { text: "Contempt", value: "Contempt", disabled: false },
        { text: "Corruption", value: "Corruption", disabled: false },
        { text: "Delirium", value: "Delirium", disabled: false },
        { text: "Doubt", value: "Doubt", disabled: false },
        { text: "Dread", value: "Dread", disabled: false },
        { text: "Envy", value: "Envy", disabled: false },
        { text: "Fear", value: "Fear", disabled: false },
        { text: "Greed", value: "Greed", disabled: false },
        { text: "Hatred", value: "Hatred", disabled: false },
        { text: "Horror", value: "Horror", disabled: false },
        { text: "Hysteria", value: "Hysteria", disabled: false },
        { text: "Insanity", value: "Insanity", disabled: false },
        { text: "Loathing", value: "Loathing", disabled: false },
        { text: "Misery", value: "Misery", disabled: false },
        { text: "Rage", value: "Rage", disabled: false },
        { text: "Scorn", value: "Scorn", disabled: false },
        { text: "Sorrow", value: "Sorrow", disabled: false },
        { text: "Spite", value: "Spite", disabled: false },
        { text: "Suffering", value: "Suffering", disabled: false },
        { text: "Torment", value: "Torment", disabled: false },
        { text: "Woe", value: "Woe", disabled: false },
        { text: "Wrath", value: "Wrath", disabled: false },
        { text: "Zeal", value: "Zeal", disabled: false },
      ],
    };
  },
  mounted() {},

  methods: {
    getHref(item) {
      if (item != undefined) {
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}]},"sort":{"price":"asc"}}`;
      }
    },
    tier(val, item) {
      if (item.tier == val) {
        return true;
      }
      return false;
    },
    type(val, item) {
      if (item.name.includes(val)) {
        return true;
      }
      return false;
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
